const stringifyValue = (value: unknown): string => (typeof value === "string" ? value : typeof value === "object" ? JSON.stringify(value) : String(value));

const toPascalCaseKey = (key: string): string => key.charAt(0).toUpperCase() + key.slice(1);

// Backend log/event DTOs only accept Record<string, string> for properties.
// Keys are normalized to PascalCase here so every log path (traces, exceptions, custom events)
// lands on consistent customDimensions/customEvents columns in Application Insights (ECSIBABS-6028).
export const toLogProperties = (properties?: Record<string, unknown>): Record<string, string> | undefined => {
  if (!properties) return undefined;

  const entries = Object.entries(properties).filter(([, value]) => value !== undefined && value !== null);

  if (entries.length === 0) return undefined;

  return Object.fromEntries(entries.map(([key, value]) => [toPascalCaseKey(key), stringifyValue(value)]));
};
